<ng-template #defaultTemplate let-option="option">
  <div class="campaign-option--sponsors">Event Info and Sponsors</div>
</ng-template>

<ng-template #auctionTemplate let-campaign="campaign" let-option="option">
  <app-currently-live-auction [campaign]="campaign" [option]="option"></app-currently-live-auction>
</ng-template>

<ng-template #donateTemplate let-option="option">
  <div class="campaign-option--live">
    <div class="campaign-option__container">
      <img class="campaign-option__image campaign-option__image--live" [src]="getImageUrl(option)" />
      <div class="campaign-option__info--live">
        <div class="campaign-option__name campaign-option__name--live">{{ option.name }}</div>
        <div class="min-step">
          <div class="min-step__label text-truncate">Pledge</div>
          <div class="min-step__value text-truncate">{{ option.amount | currency:'USD':'symbol-narrow':'1.0-0' }}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="widget__separator"></div>
</ng-template>

<ng-template #lastHeroTemplate let-campaign="campaign" let-option="option" let-list="list">
  <app-currently-live-last-hero [campaign]="campaign" [option]="option" [list]="list"></app-currently-live-last-hero>
</ng-template>

<ng-container *ngIf="campaign$ | async as campaign">
  <ng-container *ngIf="option$ | async as option">
    <ng-container *ngIf="list$ | async as list">
      <ng-container class="widget__content" *ngTemplateOutlet="presentingTemplateRef;context: getContext(campaign, option, list)"></ng-container>
    </ng-container>
  </ng-container>
</ng-container>
